var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSunriseSunset = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(368.936 -213.403)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(-368.935 213.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-248.77,216.75v-.06a5.509,5.509,0,0,0-5.53-5.4,5.509,5.509,0,0,0-5.53,5.4v.06h-3v1h17.08v-1Zm-10.06,0v-.03a4.505,4.505,0,0,1,4.53-4.43,4.512,4.512,0,0,1,4.53,4.43v.03Z",
    transform: "translate(-104.646 7.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.761,
    height: 1,
    transform: "translate(-358.141 218.106) rotate(-77.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1,
    height: 2.761,
    transform: "translate(-361.258 215.612) rotate(-12.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.762,
    height: 1,
    transform: "matrix(0.577, -0.817, 0.817, 0.577, -355.801, 218.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1,
    height: 2.762,
    transform: "matrix(0.817, -0.577, 0.577, 0.817, -364.457, 217.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.762,
    height: 1,
    transform: "translate(-353.795 220.808) rotate(-30.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1,
    height: 2.762,
    transform: "translate(-366.919 220.271) rotate(-61.001)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSunriseSunset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sunrise-sunset.245a00ee70b8316299778d7ad3cf35fe.svg";